var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D42E3931-302C-4CA3-BCB2-9D45D1CA7316") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_User-Access-Right_Data-Source-users",
    transform: "translate(-751.000000, -910.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.-Tables/01.-Alerts/05.-Filter-popup",
    transform: "translate(613.000000, 642.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(22.000000, 201.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asc",
    transform: "translate(116.000000, 66.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(5.550689, 12.244796) rotate(-180.000000) translate(-5.550689, -12.244796) translate(3.000000, 5.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 2.56154119,
    y1: 14.4895916,
    x2: 2.56154119,
    y2: 2.93098879e-14,
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "1.21236354e-13 2.45213285 2.54487453 -6.03961325e-14 5.10137841 2.45213285"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 11.531159,
    y1: 18.912385,
    x2: 14.4644923,
    y2: 18.912385,
    id: "Path-5",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.531159,
    y1: 14.912385,
    x2: 16.8112777,
    y2: 14.912385,
    id: "Path-5-Copy",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.531159,
    y1: 10.912385,
    x2: 19.3332844,
    y2: 10.912385,
    id: "Path-5-Copy-2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.531159,
    y1: 6.91238498,
    x2: 21.7139798,
    y2: 6.91238498,
    id: "Path-5-Copy-3",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsc);
export default __webpack_public_path__ + "static/media/Dsc.c766ab2419c0dd11e2f63d24af19be6e.svg";
export { ForwardRef as ReactComponent };